<sdps-modal id='delete-confirmation-modal' [sdpsTitle]="title" class="sdps-custom-modal delete-confirmation-modal" [size]="'flex--small'"
   aria-label="Delete Confirmation Modal" location="center" (close)="closeModal()">

  <div slot="modal-body">
    <sdps-notification type="error" class="sdps-m-top_none" class="sdps-text-l-body" *ngIf="invalidError">
      <div class="sdps-notification__text">
        <p *ngIf="invalidError" [innerHTML]="invalidError"></p>
      </div>
    </sdps-notification>
    <sdps-notification type="error"  class="sdps-text-l-body global-rule-error-msg">
      <div class="sdps-notification__text">
        <p [innerHTML]="globalSemiGlobalInformationMsg"></p>
      </div>
    </sdps-notification>
      <div class="globalrule-text-align">
        <div class="sdps-text-left">
          <span class="sdps-font" [innerHTML]="globalSemiGlobalConfirmationMsg"></span>
        </div>

        <form [formGroup]="globalOrSemiGlobalRuleNameDeleteForm">
          <span class="sdps-row">
            <label class="sr-only" for="globalRuleNameInput">Confirm rule name</label>
            <input id="globalRuleNameInput" class="globalrulename-Input" maxlength="100" formControlName="globalOrSemiGlobalRuleNameValue" aria-label="Confirm rule name">
          </span>
        </form>
      </div>
  </div>
  <div slot="modal-footer">
    <button type="submit" (click)="deleteorModifyRule()"  [innerHTML]="validationButtonlabel || emtrConstant.rulesConstant.ruleGlobalConst.delete" class="buttons button-save" [disabled]="!globalOrSemiGlobalRuleNameDeleteForm.get('globalOrSemiGlobalRuleNameValue').value || globalOrSemiGlobalRuleNameDeleteForm.get('globalOrSemiGlobalRuleNameValue').value?.trim() === ''"></button>
    <button class="buttons" (click)="sharedService.closeModal('delete-confirmation-modal')"
              [innerHTML]="emtrConstant.rulesConstant.rulesLanding.cancel"></button>
    </div>
</sdps-modal>
